// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ed-dialog-footer--warp[data-v-7b521135]{display:flex;align-items:center;padding:0 16px}", ""]);
// Exports
module.exports = exports;
